exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.text_template[data-v-3be01012] {\r\n  position: absolute;\r\n  z-index: 0;\r\n  background-color: transparent;\r\n  text-align: left;\n}\n.text_template .text-textarea[data-v-3be01012] {\r\n  text-align: inherit;\r\n  text-decoration: inherit;\r\n  border: 0;\r\n  background: none;\r\n  padding: 0;\r\n  cursor: move;\r\n  outline: 0;\r\n  word-break: break-all;\r\n  white-space: pre-wrap;\n}\n.text_template .text-textarea[data-v-3be01012]:focus {\r\n  cursor: text;\n}\r\n", ""]);

// exports
